import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider } from '@app/providers/AppProvider';

import '@styles/main.scss';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('[GarageWale ERP] Root element #root not found. Check index.html.');
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProvider />
  </StrictMode>,
);
